import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { OpportunityEventService } from '../../features/opportunities/services/opportunity-event.service';
import { PlannerOpportunityTypeService } from '../../features/opportunities/services/planner-opportunity-type.service';

@Injectable({
  providedIn: 'root'
})
export class OpportunityTypeInterceptor implements HttpInterceptor {
  // OpportunityEventService is resolved lazily via the Injector to break a
  // HTTP_INTERCEPTORS -> OpportunityTypeInterceptor -> OpportunityEventService
  // -> OpportunitySummaryService -> HttpClient -> HTTP_INTERCEPTORS cycle that
  // Angular's DI now refuses to resolve at construction time (NG0200).
  constructor(
    private readonly injector: Injector,
    private readonly plannerOpportunityTypeService: PlannerOpportunityTypeService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.headers.has('X-OpportunityType') ||
      (!req.url.includes('opportunities/schema') &&
        (!req.url.includes('opportunities/') || req.method !== 'PUT'))
    ) {
      return next.handle(req);
    }

    // Check planner service first (set synchronously by planner to avoid race condition)
    const plannerOpportunityType = this.plannerOpportunityTypeService.getOpportunityType();
    if (plannerOpportunityType) {
      const updatedHeaders = req.headers.set('X-OpportunityType', plannerOpportunityType);
      const updatedRequest = req.clone({ headers: updatedHeaders });
      return next.handle(updatedRequest);
    }

    const opportunityEventService = this.injector.get(OpportunityEventService);
    return opportunityEventService.selectedOpportunitySummaryOrNull$.pipe(
      take(1),
      switchMap((opportunity) => {
        if (!opportunity?.summary.opportunityType) {
          return next.handle(req);
        }

        const updatedHeaders = req.headers.set(
          'X-OpportunityType',
          opportunity.summary.opportunityType
        );
        const updatedRequest = req.clone({ headers: updatedHeaders });
        return next.handle(updatedRequest);
      })
    );
  }
}
